import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//
import { useTranslation } from "@limitless/common/hooks";
const useStyles = makeStyles(theme => ({
  privacyNoteLink: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    cursor: "pointer"
  }
}));
const PrivacyInfo = ({
  triggerPrivacyOverlay,
  text
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    display: "inline",
    style: {
      fontWeight: 500
    }
  }, text ? t(text) : t("Please read about how we handle your data in our"), " "), /*#__PURE__*/React.createElement(Typography, {
    display: "inline",
    className: classes.privacyNoteLink,
    onClick: () => triggerPrivacyOverlay()
  }, t("Privacy Notice")));
};
export default PrivacyInfo;
PrivacyInfo.propTypes = {
  triggerPrivacyOverlay: PropTypes.func.isRequired,
  text: PropTypes.string
};